import gql from "graphql-tag";

export const regionsQuery = gql`
  query regions {
    regions {
      id
      name
      country {
        id
        name
      }
    }
  }
`;
